import {Box, Text, Flex, Heading, SimpleGrid} from '@chakra-ui/react';
import React from 'react';
import BoxCard from '../../../General/BoxCard';
import {CustomCheckbox} from '../../../General/FormInputs';

const OppPlanType = props => {
  return (
    <BoxCard rounded="lg" mb="2" w="30%">
      <Heading size="md" mb="2">
        Opportunity Plan Type
      </Heading>
      <SimpleGrid columns={2} spacing="3">
        <CustomCheckbox
          w="100%"
          name="Funeral"
          id="emFloc"
          control={props.control}
          // w="100%"
          // onChange={e => fixChecks(e, 0, 1)}
        />
        <CustomCheckbox
          w="100%"
          control={props.control}
          // onChange={e => fixChecks(e, 1, 1)}
          id="emCloc"
          name="Cremation"
        />
        <CustomCheckbox
          w="100%"
          control={props.control}
          //  onChange={e => fixChecks(e, 2, 1)}
          id="emCeloc"
          name="Cemetery"
        />
        <CustomCheckbox
          w="100%"
          control={props.control}
          // onChange={e => fixChecks(e, 3, 1)}
          id="emMloc"
          name="Monument"
        />
        <CustomCheckbox
          w="100%"
          control={props.control} // onChange={e => fixChecks(e, 4, 1)}
          id="emPloc"
          name="PreNeed"
        />
        <CustomCheckbox
          w="100%"
          control={props.control} // onChange={e => fixChecks(e, 5, 1)}
          id="emPetloc"
          name="Pet Cremation"
        />
        <CustomCheckbox
          w="100%"
          control={props.control} // onChange={e => fixChecks(e, 6, 1)}
          id="emEloc"
          name="Event Planning"
        />
      </SimpleGrid>
    </BoxCard>
  );
};

export default OppPlanType;
